

























import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import ZenButton from '@reciprocity/button';
import { BDropdown, BDropdownItemButton } from 'bootstrap-vue';

import { ProgramStage } from '../programHelpers';
import setStatus from '../mixins/setStatus';

export default Vue.extend({
  name: 'FinalizeButton',
  components: {
    BDropdown,
    BDropdownItemButton,
    ZenButton,
  },
  mixins: [setStatus],
  props: {
    program: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      ProgramStage,
    };
  },
  computed: {
    ...mapGetters(['routes']),
    visible(): boolean {
      return this.program.stage <= ProgramStage.Finalizing;
    },
    disabled(): boolean {
      return this.program.stage < ProgramStage.Finalizing;
    },
    variant(): string {
      return this.program.stage < ProgramStage.Finalizing ? 'secondary' : 'primary';
    },
  },
  methods: {
    ...mapActions({
      showModal: 'modals/show',
      showAlert: 'alerts/show',
    }),
    async confirmFinalization() {
      try {
        const finalizationModal = {
          type: 'FinalizationCard',
          data: { program: this.program },
        };
        const controlReviewModal = {
          type: 'ControlReviewCard',
          data: { program: this.program },
        };

        await this.showModal(finalizationModal);
        await this.showModal(controlReviewModal);
      } catch {
        // User closed/canceled one of the modals
      }
    },
    async rescope() {
      try {
        this.setStatus('Draft', this.program.id, this.program.__typename);
      } catch {
        this.showAlert({
          type: 'error',
          message: 'Oops, something went wrong.',
        });
      }
    },
    reviewControls() {
      const url =
        this.routes.sorInfo
          .replace('__OBJECT_TYPE__', this.program.__typename)
          .replace('__OBJECT_ID__', this.program.dbId)
          .replace('__TAB__', 'mapped') + '/Controls';

      this.redirect(url);
    },
    redirect(url: string) {
      document.location.href = url;
    },
  },
});
